import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { SendMessageComponent } from './send-message.component';

const routes: Routes = [
    {
        path     : 'send-message',
        component: SendMessageComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
      SendMessageComponent,
    ],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class SendMessageModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/send-message/send-message.module.ts